import React, { Component } from "react";
import catchLifeCycleErrors from "utils/catchLifeCycleErrors";
import PropTypes from "prop-types";
import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";

@catchLifeCycleErrors
export default class HorseRacingRacecardsPage extends Component {

  static propTypes = {
    routes: PropTypes.object,
    params: PropTypes.object,
    location: PropTypes.object,
    route: PropTypes.object,
    HorseRacingRacePageContainer: PropTypes.element,
    HorseRacingRacecardsForDateContainer: PropTypes.element,
    HorseRacingLiveShowPage: PropTypes.element
  };

  render() {
    const {
      location,
      HorseRacingRacePageContainer,
      HorseRacingLiveShowPage,
      HorseRacingRacecardsForDateContainer } = this.props;

    return (
      <StandardPage sport="racing" title="Racecards">
        <div className="main-layout-left-column">
          { HorseRacingRacePageContainer }
          { HorseRacingLiveShowPage }
          { HorseRacingRacecardsForDateContainer }

          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingRacecardsPage.js